import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import animator from '../../../../helpers/animator';
import pencilIcon from '../../../../assets/images/pencil.svg';
import pencilIconGray from '../../../../assets/images/pencil-highlight.svg';
import TaskMenuPopup from '../../../../components/TaskMenuPopup';
import TaskCardInner from '../../../../components/TaskCardInner';
import DataSource from '../../../../dao/DataSource/DataSource';
import './TaskCard.scss';

export default class TaskCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
    };
  }

  handleTaskUpdated(task, action, acData, fetchedData) {
    if (acData && acData.type == 'updateTaskAssignments') {
      this.taskDataSource.get('actionCableHandler', true);  
    }
    else {
      this.setState({ task });
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.taskId) {
      this.taskDataSource = new DataSource('Task', this.props.taskId, {
        task: {
          project: {},
          user_task_assignments: {
            user: {
              additionalFields: ['profile_image'],
              companies: {},
            },
          },
        },
      }, this.handleTaskUpdated);
      this.taskDataSource.get(true);
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.quickAssignments && this.state.selected) {
      this.setState({ selected: false });
    }
  }

  handleOnHoverIn() {
    if (this.props.permissions && this.props.permissions.canEditTask && !this.props.quickAssignments) {
      this.setState({ hoveredOver: true });
    }
  }

  handleOnHoverOut() {
    this.setState({ hoveredOver: false });
  }

  handlePencilOnHoverIn() {
    if (!this.props.quickAssignments) {
      this.setState({ pencilHoveredOver: true });
    }
  }

  handlePencilOnHoverOut() {
    this.setState({ pencilHoveredOver: false });
  }

  handleSelection() {
    if (this.props.selectTask && !this.dragging && !this.props.selectDisabled) {
      this.props.selectTask(this.state.task, this.state.task.project);
    }
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (!this.dragging && this.dragElement && this.dragElement == element && !this.dragObject) {
      this.dragging = true;
      let bodyElement = document.body;
      // if (this.props.dragParentId) {
      //   bodyElement = document.getElementById(this.props.dragParentId)
      // }
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = .8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.state.task, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    // if (this.props.dragParentId) {
    //   bodyElement = document.getElementById(this.props.dragParentId)
    // }
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    this.dragObject = null;
    if (this.props.handleDropping) {
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.task, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      if (this.props.handleDragging) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.props.handleDragging) {
      if (!this.dragging && e.which == 1) {
        if ((this.startX && Math.abs(this.startX - e.clientX) > 5) ||
          (this.startY && Math.abs(this.startY - e.clientY) > 5)) {
          if (this.cardElement) {
            this.handleStartDrag(this.cardElement);
          }
        }
      }
    }
  }

  handlePencilClick(e) {
    e.stopPropagation();
    this.setState({ menuOpen: true, hoveredOver: false, pencilHoveredOver: false });
  }

  handleCloseTaskMenu() {
    this.setState({ menuOpen: false, hoveredOver: false, pencilHoveredOver: false });
  }

  handleTaskDeleted(task) {
    if (this.props.handleTaskDeleted) {
      this.props.handleTaskDeleted(task);
    }
  }

  render() {
    if (!this.state.task) {
      return null;
    }

    let bulkAssignFilter = null;
    if (this.props.selectDisabled) {
      bulkAssignFilter = <div className="bulk-assign-filter" />;
    }

    let pencil = pencilIcon;
    if (this.state.pencilHoveredOver && !this.props.quickAssignments) {
      pencil = pencilIconGray;
    }

    let taskPopupMenu = null;
    if (this.state.menuOpen && this.cardElement) {
      const rects = this.cardElement.getClientRects();
      taskPopupMenu = (
        <TaskMenuPopup 
          task={this.state.task}
          cardRect={rects[0]}
          handleClosePopup={this.handleCloseTaskMenu} 
          handleTaskDeleted={this.handleTaskDeleted}
          handleAddCopiedTask={this.props.handleAddCopiedTask}
          currentUser={this.props.currentUser}
          isFromTemplate={false}
        />
      );
    }

    return (
      <div>
        {taskPopupMenu}
        <div className={'task-card' + (this.props.selected ? ' selected' : '') + (this.props.quickAssignments ? ' bulk-assign' : '') + (this.props.isTaskCopied ? ' fade-in' : '')}
          onClick={this.handleSelection} onMouseDown={this.handleMouseDown}
          onMouseUp={this.handleMouseUp} onMouseMove={this.handleMouseMove}
          id={this.props.id} ref={(element) => { this.cardElement = element; }}
          onMouseEnter={this.handleOnHoverIn} onMouseLeave={this.handleOnHoverOut}
        >
          {bulkAssignFilter}
          <TaskCardInner task={this.state.task} quickAssignments={this.props.quickAssignments} selectDisabled={this.props.selectDisabled}/>
          {this.props.inProjectsTab && this.state.hoveredOver && (
            <div className={'pencil-icon' + (this.state.pencilHoveredOver ? ' hovered-over' : '')}
              onMouseEnter={this.handlePencilOnHoverIn} onMouseLeave={this.handlePencilOnHoverOut}
              onClick={this.handlePencilClick}
            >
              <img
                alt="edit" src={pencil} onClick={this.handlePencilClick}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/TasksContainerTasks/TaskCard/index.js